import _ from 'lodash'
import { useContext, useEffect } from 'react'
import { useFormState } from 'react-hook-form'

import { AdUnitListContext } from 'features/inventory/ad-unit/contexts/AdUnitListContext'

import type { AdUnitTableSchema } from 'features/inventory/ad-unit/forms/AdUnitTableForm/schema'
import type { DirtyAdUnitsAttributes } from 'features/inventory/ad-unit/forms/AdUnitTableForm/types'

export const useCollectDirtyAdUnitsAttributes = (): void => {
  const { dirtyAdUnitsAttributes, setDirtyAdUnitsAttributes } = useContext(AdUnitListContext)

  const formState = useFormState<AdUnitTableSchema>()
  const { dirtyFields } = formState

  useEffect(() => {
    if (setDirtyAdUnitsAttributes !== undefined) {
      const dirty: DirtyAdUnitsAttributes = dirtyFields.adUnitsAttributes ?? {}

      if (!_.isEqual(dirtyAdUnitsAttributes, dirty)) {
        setDirtyAdUnitsAttributes(_.cloneDeep(dirty))
      }
    }
  }, [formState, setDirtyAdUnitsAttributes])
}
